import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgPid/roles')({
  component: RolesPage,
});

function RolesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Roles & Permissions</h1>
        <p className="text-muted-foreground">
          Manage roles and control what each team member can access
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Roles</CardTitle>
          <CardDescription>
            Define roles with specific permissions and assign them to organization members.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">
            Default roles: Owner, Admin, Member. Custom roles coming soon.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
